import type { VotingPeriod } from "@book-club/shared";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { votingQueryKeys } from "@/features/voting/queries/votingQueryKeys";
import votingService from "@/features/voting/services/votingService";

type UpdateVotingPeriodVariables = {
    endsAt: string;
    startsAt: string;
    votingPeriodId: string;
};

export function useUpdateVotingPeriod() {
    const queryClient = useQueryClient();

    return useMutation<VotingPeriod, Error, UpdateVotingPeriodVariables>({
        mutationFn: async (variables) => {
            return await votingService.updateVotingPeriod(variables);
        },
        onError: (error) => {
            const errorMessage = error instanceof Error ? error.message : "Failed to update voting period";
            toast.error(errorMessage);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: votingQueryKeys.periods() });
            toast.success("Voting period updated successfully");
        },
    });
}
